import { fetchProductSegmentsProductsBySegmentType } from '@eliadmin/core/src/api/product-segments/product-segments-api';
import { fetchProducts } from '@eliadmin/core/src/api/products/product-api';
import type { ProductDisplayData } from '@eliadmin/core/src/api/products/types/product-types';
import { buildProductsQuery } from '@eliadmin/core/src/utils/product-utils';

/** Figma 23:1895: the banner and six tiles (two next to it, four below). */
const BESTSELLERS_COUNT = 6;

/**
 * Bestsellers as the core homepage reads them – the product segment of type `bestsellers`
 * (Produktové segmenty) – and, while no such segment has products, the catalogue by sales count
 * (the core category bestsellers sort). Server seed and logged-in refresh use the same request.
 */
export async function fetchBestsellers({
  locale,
  authToken,
}: {
  locale: string;
  authToken?: string;
}): Promise<ProductDisplayData[]> {
  const segment = await fetchProductSegmentsProductsBySegmentType({
    locale,
    authToken,
    segmentType: 'bestsellers',
    query: buildProductsQuery({ results: BESTSELLERS_COUNT }),
  });
  if (segment.data.length) return segment.data;

  const { data } = await fetchProducts({
    locale,
    authToken,
    query: buildProductsQuery({ results: BESTSELLERS_COUNT, orderBy: 'sells', order: 'desc' }),
  });
  return data;
}
